import { render } from "./BeneficiariesList.vue?vue&type=template&id=0251cc32&scoped=true"
import script from "./BeneficiariesList.vue?vue&type=script&lang=js"
export * from "./BeneficiariesList.vue?vue&type=script&lang=js"

import "./BeneficiariesList.vue?vue&type=style&index=0&id=0251cc32&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0251cc32"]])

export default __exports__